<template>
    <div id="menu-mobile">
        <div class="logo">
          <router-link to="/">
            <a><img :src="logo" alt=""></a>
          </router-link>
        </div>
        <div id="toggle" @click="menuToogle">
            <div class="one"></div>
            <div class="two"></div>
            <div class="three"></div>
        </div>
        <div id="menu">
            <div class="row">
              <div class="col-md-12">
                <ul>
                  <li>
                    <router-link to="/">
                      <a @click="menuToogle">Home</a>
                    </router-link>
                  </li>
                  <li>
                      <router-link to="/produtos">
                        <a @click="menuToogle">Productos</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/empresa">
                        <a @click="menuToogle">negocios</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/representantes">
                        <a @click="menuToogle">Representantes</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/social">
                        <a @click="menuToogle">Social</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/trabalhe-conosco">
                        <a @click="menuToogle">Trabaja con nosotros</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/downloads">
                        <a @click="menuToogle">Downloads</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/contato">
                        <a @click="menuToogle">Contacto</a>
                      </router-link>
                  </li>
                  <li>
                      <router-link to="/nfe">
                        <a @click="menuToogle">NF-E</a>
                      </router-link>
                  </li>
                </ul>
              </div>
              <div class="col-md-12">
                <div class="languages">
                  <ul>
                    <li><a href="http://funada-es.ataquepropaganda.com.br/"><img src="../assets/idiomas/spain.png" alt=""></a></li>
                <li><a href="http://funada-en.ataquepropaganda.com.br/"><img src="../assets/idiomas/usa.png" alt=""></a></li>
                    <!-- <li><a href="http://jp-funada.ataquepropaganda.com.br/"><img src="../assets/idiomas/jp.png" alt=""></a></li> -->
                    <li><a href="http://funada.ataquepropaganda.com.br/"><img src="../assets/idiomas/br.png" alt=""></a></li>
                  </ul>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("../assets/logo.png")
    };
  },

  methods: {
    menuToogle() {
      var menu = document.querySelector("#menu");
      var button = document.querySelector("#toggle");

      if (menu.classList.contains("on")) {
        menu.classList.remove("on");
      } else {
        menu.classList.toggle("on");
      }

      if (button.classList.contains("on")) {
        button.classList.remove("on");
      } else {
        button.classList.toggle("on");
      }
    }
  }
};
</script>

<style scoped>

.logo img {
  float: left;
  width: 128px;
  padding-left: 10px;
  padding-top: 6px;
}

#menu-mobile {
  width: 100%;
  height: 70px;
  background: #ebc228;
  position: fixed;
  z-index: 1;
  -webkit-box-shadow: -3px 0 3px 0 #000000;
  box-shadow: -3px 0 3px 0 #000000;
}

#toggle {
  width: 28px;
  height: 30px;
  float: right;
  margin-right: 15px;
  margin-top: 20px;
}

#toggle div {
  width: 100%;
  height: 5px;
  background: #090c9a;
  margin: 4px auto;
  transition: all 0.3s;
  backface-visibility: hidden;
}

#toggle.on .one {
  transform: rotate(45deg) translate(5px, 5px);
}

#toggle.on .two {
  opacity: 0;
}

#toggle.on .three {
  transform: rotate(-45deg) translate(7px, -8px);
}

#menu {
  color: black;
  background: #ebc228;
  width: 100%;
  height: 100vh;
  padding: 10px;
  font-family: "Bambino";
  line-height: 100px;
  text-align: left;
  margin-top: 68px;
  list-style: none;
  text-align: center;
  text-transform: uppercase;
  padding-top: 25px;
  visibility: hidden;
  opacity: 0;
  -webkit-transition: visibility 0s, opacity 0.3s linear;
  transition: visibility 0s, opacity 0.3s linear;
}

#menu.on {
  visibility: visible;
  opacity: 1;
}

#menu ul {
  list-style: none;
  margin-left: -50px;
}

#menu li {
  text-indent: 20px;
  line-height: 35px;
  font-family: "Bambino";
  font-size: 12pt;
}

#menu li a {
  display: block;
  text-decoration: none;
  color: #090c9a;
}

#menu li a:hover {
  text-decoration: none;
  color: #000;
}

#menu li a:active,
#menu li a:focus {
  text-decoration: none;
}

.languages {
  float: left;
  margin-top: 20px;
  margin-left: 85px;
}

.languages ul {
  list-style: none;
  float: left;
  display: inline-flex;
  padding-left: 10px;
  margin-left: 0;
}

.languages ul>li {
  margin-left: 5px;
}

.languages ul>li:first-child {
  margin-left: 0px;
}

@media (min-width: 1024px) {
  #menu-mobile {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MenuMobile.vue